var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256.000000 256.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
      "fill": _vm.primary,
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1610 2274 c-162 -69 -303 -135 -312 -146 -16 -18 -18 -44 -18 -227\n0 -309 20 -446 86 -589 46 -102 108 -185 205 -276 97 -91 311 -236 349 -236\n38 0 252 145 349 236 97 91 159 174 205 276 66 143 86 280 86 589 0 183 -2\n209 -17 227 -18 20 -595 272 -624 272 -8 0 -147 -57 -309 -126z m583 -365 c26\n-12 47 -47 47 -78 0 -26 -335 -443 -370 -460 -52 -25 -78 -4 -174 139 -47 71\n-88 139 -91 152 -15 58 36 106 97 93 21 -5 41 -26 80 -83 28 -43 54 -81 58\n-85 5 -5 65 62 135 150 149 185 164 197 218 172z"
    }
  }), _c('path', {
    attrs: {
      "d": "M94 1906 c-17 -8 -44 -31 -60 -52 l-29 -37 -3 -189 -3 -188 577 0\n577 0 -7 43 c-16 94 -26 218 -26 325 l0 112 -497 0 c-397 -1 -504 -4 -529 -14z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2 692 l3 -429 27 -35 c56 -73 -37 -69 1261 -66 l1164 3 37 29 c67\n51 67 48 64 512 l-3 416 -34 -47 c-88 -122 -244 -257 -420 -364 -156 -94 -206\n-94 -362 0 -167 101 -313 225 -401 340 l-53 69 -643 0 -643 0 3 -428z m772 82\nc28 -29 32 -53 14 -87 -23 -44 -35 -46 -220 -47 -193 0 -220 6 -239 51 -14 36\n2 81 34 97 13 6 98 11 203 11 l181 1 27 -26z"
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };